import { Link } from 'react-router-dom';

/**
 * Footer component for pre-authentication screens (Login, Signup, etc.)
 * Contains links to Terms, Privacy, Contact, and About pages.
 */
export function PreAuthFooter() {
  return (
    <footer 
      className="mt-8 pt-6 border-t border-qc-border"
      data-testid="pre-auth-footer"
    >
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-qc-text-faint">
        <Link 
          to="/terms" 
          className="hover:text-qc-text-dim transition-colors"
          data-testid="footer-terms-link"
        >
          Terms
        </Link>
        <span className="text-qc-border">•</span>
        <Link 
          to="/privacy" 
          className="hover:text-qc-text-dim transition-colors"
          data-testid="footer-privacy-link"
        >
          Privacy
        </Link>
        <span className="text-qc-border">•</span>
        <Link 
          to="/contact" 
          className="hover:text-qc-text-dim transition-colors"
          data-testid="footer-contact-link"
        >
          Contact
        </Link>
        <span className="text-qc-border">•</span>
        <Link 
          to="/about" 
          className="hover:text-qc-text-dim transition-colors"
          data-testid="footer-about-link"
        >
          About
        </Link>
      </div>
      <p className="text-center text-[10px] text-qc-text-faint mt-3">
        © {new Date().getFullYear()} Get Green Light
      </p>
    </footer>
  );
}
